import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Container, IconButton } from '@mui/material';
import PropTypes from 'prop-types';

import { ReactComponent as NavigationArrow } from 'assets/icons/navigation-arrow.svg';
import FocusableHeader from 'components/focusableheader/FocusableHeader';
import Link from 'components/link/Link';

const EditProfileWrapper = (props) => {
    const { children, goBack, title } = props;
    const { formatMessage } = useIntl();

    return (
        <Container className="edit-profile-container grey-banner" maxWidth="false">
            <Box className="edit-profile-heading">
                {typeof goBack !== 'string' ? (
                    <IconButton onClick={goBack} title={formatMessage({ id: 'pages.profile.edit.go.back' })}>
                        <NavigationArrow className="navigation-arrow" />
                    </IconButton>
                ) : (
                    <Link title={formatMessage({ id: 'pages.profile.edit.go.back' })} to={goBack}>
                        <NavigationArrow className="navigation-arrow" />
                    </Link>
                )}
                <FocusableHeader className="edit-profile-title">
                    <FormattedMessage id={title} />
                </FocusableHeader>
            </Box>
            {children}
        </Container>
    );
};

EditProfileWrapper.propTypes = {
    children: PropTypes.object.isRequired,
    goBack: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
    title: PropTypes.string.isRequired,
};

export default EditProfileWrapper;
